import React from 'react';

import { SimpleIcon } from './icon-utils';

export function FolderSyncingIcon(): JSX.Element {
  return (
    <SimpleIcon fill="none" height="18" viewBoxDimensions="0 0 18 18" width="18">
      <path
        d="M14.25 5.205H9.39675C9.1485 5.205 8.916 5.082 8.7765 4.8765L7.72275 3.32775C7.58325 3.123 7.3515 3 7.10325 3H3.75C2.92125 3 2.25 3.67125 2.25 4.5V13.5C2.25 14.3288 2.92125 15 3.75 15H14.25C15.0788 15 15.75 14.3288 15.75 13.5V6.705C15.75 5.877 15.0788 5.205 14.25 5.205Z"
        fillRule="evenodd"
        stroke="#849297"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.2686 9.75C11.3879 10.4587 11.1801 11.2102 10.6326 11.7577C9.94787 12.4425 8.93987 12.606 8.09912 12.2505"
        stroke="#849297"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M9.90077 7.99961C9.06002 7.64411 8.05277 7.80686 7.36727 8.49236C6.81977 9.03986 6.61202 9.79136 6.73127 10.5001"
        stroke="#849297"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M9.5047 7.36426L10.0207 7.88026L9.5047 8.39551"
        stroke="#849297"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M8.4953 11.8545L7.9793 12.3697L8.4953 12.8857"
        stroke="#849297"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SimpleIcon>
  );
}
